import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { logInSuccess, signUpSuccess, updateMembershipStatusSuccess } from '@techstyle/react-accounts';
import { createAction, createReducer, createSelector, outOfDateStatus, upToDateStatus, startLoading, stopLoading, createCachedSelector, loadSessionSuccess } from '@techstyle/redux-core';
import logger from './logger';
var debug = logger.extend('abTestModule');
export var initialState = {
  forceAllControl: false,
  shouldUseActivatedTests: false,
  requestedTests: {},
  activatedTests: {
    data: [],
    fetchedDate: null,
    networkStatus: outOfDateStatus()
  },
  testsUsedOnPage: []
};
export var defaultTestData = {
  campaignCode: '',
  data: {
    group: 0,
    cohortNumber: 1,
    enabled: false,
    activated: false
  },
  fetchedDate: null,
  networkStatus: outOfDateStatus()
};
export var TestErrorType = {
  OTHER: 'OTHER'
};
export var setShouldUseActivatedTests = createAction('abTest/setShouldUseActivatedTests');
export var invalidateTests = createAction('abTest/invalidateTests');
export var markTestUsedOnPage = createAction('abTest/markTestUsedOnPage');
export var clearTestsUsedOnPage = createAction('abTest/clearTestsUsedOnPage');
export var loadAllTestsRequest = createAction('abTest/loadAllTestsRequest');
export var loadAllTestsSuccess = createAction('abTest/loadAllTestsSuccess');
export var loadAllTestsFailure = createAction('abTest/loadAllTestsFailure');
export var loadActivatedTestsRequest = createAction('abTest/loadActivatedTestsRequest');
export var loadActivatedTestsSuccess = createAction('abTest/loadActivatedTestsSuccess');
export var loadActivatedTestsFailure = createAction('abTest/loadActivatedTestsFailure');
export var invalidateActivatedTests = createAction('abTest/invalidateActivatedTests');
export var setForceAllTestsControl = createAction('abTest/setForceAllTestsControl');
export var forceTestCohortRequest = createAction('abTest/forceTestCohortRequest');
export var forceTestCohortSuccess = createAction('abTest/forceTestCohortSuccess');
export var forceTestCohortFailure = createAction('abTest/forceTestCohortFailure');
export var splitTestRequest = createAction('abTest/splitTestRequest');
export var splitTestSuccess = createAction('abTest/splitTestSuccess');
export var splitTestFailure = createAction('abTest/splitTestFailure'); // We don't want to import the features here, so we just create a copy of the

var loadFeaturesSuccess = createAction('features/loadFeaturesSuccess');
/**
 * Loads tests that the current user has been assigned a group for.
 * The endpoint implies "activated" tests, but really returns all tests
 * that are enabled for the current user (control or variant)
 */

export function loadActivatedTests() {
  var forceRequest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var request = {
    bentoApi: {
      endpoint: 'tests/activated',
      requestKey: 'loadActivatedTests',
      actions: [loadActivatedTestsRequest, loadActivatedTestsSuccess, loadActivatedTestsFailure]
    }
  };

  if (forceRequest) {
    return request;
  }

  return (dispatch, getState) => {
    var state = getState();
    var activatedTests = state.abTest.activatedTests;
    var networkStatus = activatedTests.networkStatus;

    if (!networkStatus.isUpToDate) {
      return dispatch(request);
    }
  };
} // Enable test for user and assign random value if none exists

export function splitTest(campaignCode) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref$activate = _ref.activate,
      activate = _ref$activate === void 0 ? true : _ref$activate,
      _ref$explain = _ref.explain,
      explain = _ref$explain === void 0 ? false : _ref$explain,
      _ref$expireCache = _ref.expireCache,
      expireCache = _ref$expireCache === void 0 ? true : _ref$expireCache,
      _ref$forceRequest = _ref.forceRequest,
      forceRequest = _ref$forceRequest === void 0 ? false : _ref$forceRequest,
      _ref$usedOnPage = _ref.usedOnPage,
      usedOnPage = _ref$usedOnPage === void 0 ? true : _ref$usedOnPage,
      options = _objectWithoutProperties(_ref, ["activate", "explain", "expireCache", "forceRequest", "usedOnPage"]);

  return (dispatch, getState) => {
    var state = getState();

    var _getTest = getTest(state, campaignCode),
        error = _getTest.error,
        networkStatus = _getTest.networkStatus;

    if (usedOnPage) {
      dispatch(markTestUsedOnPage(campaignCode));
    }

    var shouldFetch = false;

    if (forceRequest) {
      shouldFetch = true;
    } else if (error) {
      debug('A/B test “%s” has error; skipping refetch.', campaignCode);
    } else if (!networkStatus.isUpToDate && !networkStatus.isLoading) {
      debug('A/B test “%s” is invalidated; refetching.', campaignCode);
      shouldFetch = true;
    }

    if (shouldFetch) {
      return dispatch({
        bentoApi: {
          endpoint: "tests/".concat(campaignCode, "/split"),
          method: 'POST',
          json: _objectSpread(_objectSpread({}, options), {}, {
            activate,
            explain,
            expireCache,
            campaignCode
          }),
          requestKey: "splitTest:".concat(campaignCode),
          actions: [(payload, meta) => splitTestRequest(payload, _objectSpread(_objectSpread({}, meta), {}, {
            campaignCode
          })), (payload, meta) => splitTestSuccess(payload, _objectSpread(_objectSpread({}, meta), {}, {
            campaignCode
          })), (payload, meta) => splitTestFailure(payload, _objectSpread(_objectSpread({}, meta), {}, {
            campaignCode
          }))]
        }
      });
    }
  };
} // Forces user test participation to a specific cohort

export function forceTestCohort(campaignCode) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref2$cohortNumber = _ref2.cohortNumber,
      cohortNumber = _ref2$cohortNumber === void 0 ? 2 : _ref2$cohortNumber,
      _ref2$explain = _ref2.explain,
      explain = _ref2$explain === void 0 ? false : _ref2$explain,
      _ref2$expireCache = _ref2.expireCache,
      expireCache = _ref2$expireCache === void 0 ? true : _ref2$expireCache,
      options = _objectWithoutProperties(_ref2, ["cohortNumber", "explain", "expireCache"]);

  return {
    bentoApi: {
      endpoint: "tests/".concat(campaignCode, "/force"),
      method: 'POST',
      json: _objectSpread(_objectSpread({}, options), {}, {
        cohortNumber
      }),
      actions: [(payload, meta) => forceTestCohortRequest(payload, _objectSpread(_objectSpread({}, meta), {}, {
        campaignCode
      })), (payload, meta) => forceTestCohortSuccess(payload, _objectSpread(_objectSpread({}, meta), {}, {
        campaignCode
      })), (payload, meta) => forceTestCohortFailure(payload, _objectSpread(_objectSpread({}, meta), {}, {
        campaignCode
      }))]
    }
  };
} // Loads all system A/B test data

export function loadAllTests() {
  return {
    bentoApi: {
      endpoint: 'tests',
      requestKey: 'loadAllTests',
      actions: [loadAllTestsRequest, loadAllTestsSuccess, loadAllTestsFailure]
    }
  };
}

function handleTestRequest(state, action) {
  var campaignCode = action.meta.campaignCode;

  if (!state.requestedTests[campaignCode]) {
    state.requestedTests[campaignCode] = {
      fetchedDate: action.meta.fetchedDate,
      networkStatus: outOfDateStatus()
    };
  }

  startLoading(state.requestedTests[campaignCode]);
}

function handleTestSuccess(state, action) {
  var _action$meta = action.meta,
      campaignCode = _action$meta.campaignCode,
      fetchedDate = _action$meta.fetchedDate;
  var test = action.payload;
  state.requestedTests[campaignCode] = {
    data: test,
    error: null,
    fetchedDate,
    networkStatus: upToDateStatus()
  };
}

function handleTestFailure(state, action) {
  var campaignCode = action.meta.campaignCode;
  var test = state.requestedTests[campaignCode];

  if (test) {
    // TODO: Can we determine more specific error types?
    test.error = TestErrorType.OTHER;
    stopLoading(test);
  }
}

function handleActivatedTestsRequest(state) {
  startLoading(state.activatedTests);
}

function handleActivatedTestsSuccess(state, action) {
  var tests = action.payload,
      fetchedDate = action.meta.fetchedDate;
  state.activatedTests = {
    data: tests,
    fetchedDate,
    networkStatus: upToDateStatus()
  };

  if (state.shouldUseActivatedTests) {
    tests.forEach(test => {
      var campaignCode = test.campaignCode;
      var existingTest = state.requestedTests[campaignCode];
      var isActivatedTestNewer = !existingTest ? true : Date.parse(fetchedDate) > Date.parse(existingTest.fetchedDate);

      if (isActivatedTestNewer) {
        state.requestedTests[campaignCode] = {
          data: _objectSpread(_objectSpread({}, test), {}, {
            enabled: true,
            activated: test.group > 1
          }),
          fetchedDate,
          networkStatus: upToDateStatus()
        };
      }
    });
  }
}

function handleActivatedTestsFailure(state) {
  stopLoading(state.activatedTests);
}

function invalidateRequestedTests(state) {
  Object.keys(state.requestedTests).forEach(campaignCode => {
    state.requestedTests[campaignCode].networkStatus = outOfDateStatus();
  });
  state.activatedTests.networkStatus = outOfDateStatus();
}

export var abTestReducer = createReducer(initialState, {
  [setForceAllTestsControl]: (state, action) => {
    state.forceAllControl = action.payload;
  },
  [setShouldUseActivatedTests]: (state, action) => {
    state.shouldUseActivatedTests = action.payload;
  },
  [splitTestRequest]: handleTestRequest,
  [splitTestFailure]: handleTestFailure,
  [splitTestSuccess]: handleTestSuccess,
  [forceTestCohortRequest]: handleTestRequest,
  [forceTestCohortFailure]: handleTestFailure,
  [forceTestCohortSuccess]: handleTestSuccess,
  [loadActivatedTestsRequest]: handleActivatedTestsRequest,
  [loadActivatedTestsFailure]: handleActivatedTestsFailure,
  [loadActivatedTestsSuccess]: handleActivatedTestsSuccess,
  [invalidateActivatedTests]: state => {
    state.activatedTests.networkStatus = outOfDateStatus();
  },
  [markTestUsedOnPage]: (state, action) => {
    var campaignCode = action.payload;

    if (!state.testsUsedOnPage.includes(campaignCode)) {
      state.testsUsedOnPage.push(campaignCode);
    }
  },
  [clearTestsUsedOnPage]: (state, action) => {
    state.testsUsedOnPage = [];
  },
  [invalidateTests]: invalidateRequestedTests,
  [loadSessionSuccess]: (state, action) => {
    if (action.meta.customerDidChange) {
      invalidateRequestedTests(state);
    }
  },
  [logInSuccess]: invalidateRequestedTests,
  [signUpSuccess]: invalidateRequestedTests,
  [updateMembershipStatusSuccess]: invalidateRequestedTests,
  [loadFeaturesSuccess]: (state, action) => {
    var meta = action.meta;

    if (meta !== null && meta !== void 0 && meta.shouldInvalidateABTests) {
      state.activatedTests.networkStatus = outOfDateStatus();
    }
  }
});
export function createTest(campaignCode, test, forceAllControl) {
  if (test) {
    if (test.data) {
      return _objectSpread(_objectSpread({
        campaignCode
      }, test), {}, {
        data: _objectSpread(_objectSpread({}, test.data), {}, {
          cohortNumber: forceAllControl ? 1 : test.data.cohortNumber,
          group: forceAllControl ? 1 : test.data.group,
          isControl: forceAllControl ? true : test.data.cohortNumber <= 1,
          isVariant: forceAllControl ? false : test.data.cohortNumber > 1
        })
      });
    }

    return _objectSpread({
      campaignCode
    }, test);
  }

  return {
    campaignCode,
    fetchedDate: null,
    networkStatus: outOfDateStatus()
  };
}
var getCachedTest = createCachedSelector([(abTest, campaignCode) => campaignCode, (abTest, campaignCode) => abTest.requestedTests[campaignCode], abTest => abTest.forceAllControl], createTest)((abTest, campaignCode) => campaignCode);
export function getTest(state, campaignCode) {
  return getCachedTest(state.abTest, campaignCode);
}
export var getTestsUsedOnPage = createSelector([state => state.abTest], abTest => {
  return abTest.testsUsedOnPage.map(campaignCode => getCachedTest(abTest, campaignCode));
});
export var getRequestedTests = createSelector([state => state.abTest], abTest => {
  return Object.keys(abTest.requestedTests).map(campaignCode => getCachedTest(abTest, campaignCode));
});

function initABTestModule() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    shouldUseActivatedTests: false
  },
      shouldUseActivatedTests = _ref3.shouldUseActivatedTests;

  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(function* (dispatch, getState, context) {
      if (shouldUseActivatedTests) {
        dispatch(setShouldUseActivatedTests(true));

        if (context.isServer && !context.hasPreloadedState) {
          var isAnonymous = context.req.context.anonymousServerSession;

          if (!isAnonymous) {
            dispatch(loadActivatedTests());
          }
        }

        if (!context.isServer) {
          dispatch(loadActivatedTests());
        }
      }
    });

    return function (_x, _x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();
}

export default function abTestModule() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    shouldUseActivatedTests: false
  };
  return {
    id: 'abTest',
    reducerMap: {
      abTest: abTestReducer
    },
    initialActions: [initABTestModule(options)]
  };
}